import { useMutation, useQuery } from "react-query";
import { DirectEmissions } from "../../../api";
import { useAuth } from "../../../context";

export const directEmissionsKeys = {
  items: () => ["directEmissionsItems"]
};

export function useGetDirectEmissionsItems(params, config) {
  const { callApi } = useAuth();
  return useQuery([...directEmissionsKeys.items(), params.type, params.queryParams.page],
    () => callApi(DirectEmissions.getDirectEmissionsItems, params), config);
}

export function useCreateDirectEmissions(config) {
  const { callApi } = useAuth();
  return useMutation(({questionnaireId, data}) =>
    callApi(DirectEmissions.createDirectEmissions, { questionnaireId, data }), config);
}

export function useUpdateDirectEmissions(config) {
  const { callApi } = useAuth();
  return useMutation(({questionnaireId, id, data}) =>
    callApi(DirectEmissions.updateDirectEmissions, { questionnaireId, id, data }), config);
}

export function useAddDirectEmissionsItem(config) {
  const { callApi } = useAuth();
  return useMutation(({questionnaireId, data, type}) =>
    callApi(DirectEmissions.addDirectEmissionsItem, { questionnaireId, data, type }), config);
}

export function useUpdateDirectEmissionsItem(config) {
  const { callApi } = useAuth();
  return useMutation(({questionnaireId, recordId, data, type}) =>
    callApi(DirectEmissions.updateDirectEmissionsItem, { questionnaireId, recordId, data, type }), config);
}

export function useDeleteDirectEmissionsItem(config) {
  const { callApi } = useAuth();
  return useMutation(({questionnaireId, recordId, type}) =>
    callApi(DirectEmissions.deleteItem, { questionnaireId, recordId, type }), config);
}

